import { render, staticRenderFns } from "./RelatorioAlteracoes.vue?vue&type=template&id=81425c80"
import script from "./RelatorioAlteracoes.vue?vue&type=script&lang=js"
export * from "./RelatorioAlteracoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports